import { PaperKind } from "../../../app.constants";

export namespace OrientationKind {
  export const Portrait = 'Portrait';
  export const Landscape = 'Landscape';
}

export namespace DefaultPdfOptions
{
  export const MarginLeft = 0;
  export const MarginRight  = 0;
  export const MarginTop = 0;
  export const MarginBottom = 0;

  export const Title = "";

  export const Dpi = 96;
  export const Quality  = 80;
  export const PageSize = PaperKind.Letter;
  export const Orientation = OrientationKind.Portrait;
}

export class WkHtmlToPdfOptions {
  silentOutput: boolean;
  outline: boolean;
  enableSmartShrinking: boolean;
  printMediaType: boolean;
  title: string;
  dpi: number;
  imageDpi: number;
  quality: number;
  imageQuality: number;
  marginLeft: number;
  marginRight: number;
  marginTop: number;
  marginBottom: number;
  pageSize: string;
  orientation: string;
  lengthUnit: string;

  constructor() {
    this.silentOutput = true;
    this.outline = false;
    this.enableSmartShrinking = false;
    this.printMediaType = true;
    this.title = DefaultPdfOptions.Title;
    this.dpi = DefaultPdfOptions.Dpi;
    this.imageDpi = DefaultPdfOptions.Dpi;
    this.quality = DefaultPdfOptions.Quality;
    this.imageQuality = DefaultPdfOptions.Quality;
    this.marginLeft = DefaultPdfOptions.MarginLeft;
    this.marginRight = DefaultPdfOptions.MarginRight;
    this.marginTop = DefaultPdfOptions.MarginTop;
    this.marginBottom = DefaultPdfOptions.MarginBottom;
    this.pageSize = DefaultPdfOptions.PageSize;
    this.orientation = DefaultPdfOptions.Orientation;
    this.lengthUnit = 'mm';
  }
}
